import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Box,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface PostClosingSpecialistModalProps {
  loans: number[];
  specialists: string[];
  onConfirm: (email: string) => void;
  onClose: () => void;
}

export const PostClosingSpecialistModal: React.FC<PostClosingSpecialistModalProps> = ({
  loans,
  specialists,
  onConfirm,
  onClose,
}) => {
  const [selectedEmail, setSelectedEmail] = useState<string>('');

  const handleConfirm = () => {
    if (selectedEmail) {
      onConfirm(selectedEmail);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        disableTypography
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="h6">Reassign Post Closing Specialist</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={3}>
          <TextField
            select
            fullWidth
            label="Select Specialist (email)"
            value={selectedEmail}
            onChange={e => setSelectedEmail(e.target.value)}
            variant="outlined"
          >
            {specialists.map(email => (
              <MenuItem key={email} value={email}>
                {email}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box>
          <Typography variant="subtitle1">Loans to update:</Typography>
          <List dense>
            {loans.map((loan, index) => (
              <ListItem key={index} divider>
                <ListItemText primary={`Loan ID: ${loan}`} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedEmail}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
